var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { Placement } from '@philips-internal/oswald-ui-constants';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { array, eventListener, number } from '@philips-internal/oswald-ui-core/lib/component/prop-types/index.js';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types/index.js';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services/index.js';
import { Link } from '../link/link.js';
import { Popover } from '../popover/popover.js';
import { EventToken } from './components/event-token.js';
import EventTokenListAPI from './event-token-list-api.js';
import './event-token-list.css';
let EventTokenList = class EventTokenList extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            isPopoverOpen: false,
        };
        this.onSeeMore = () => {
            this.setState((prevState) => ({
                isPopoverOpen: !prevState.isPopoverOpen,
            }));
        };
        this.closePopover = () => {
            this.setState({ isPopoverOpen: false });
        };
        this.onEventTokenClick = (value) => {
            const { onClick } = this.props;
            onClick && onClick(new ClickEvent({ value }));
        };
        this.renderSeeMore = (hiddenEvents) => {
            const { isPopoverOpen } = this.state;
            if (!hiddenEvents.length) {
                return null;
            }
            const value = `${MessageService.translate('tws.event-token-list.see-more')} + ${hiddenEvents.length}`;
            return (React.createElement(Popover, { onClose: this.closePopover, open: isPopoverOpen, placement: Placement.BOTTOM },
                React.createElement(Link, { onClick: this.onSeeMore, value: value }),
                React.createElement(Popover.Content, null, this.renderEventTokens(hiddenEvents, 'c-event-list__hidden-events'))));
        };
        this.renderEventTokens = (events = [], className = '') => {
            return (React.createElement("div", { className: className }, events.map((event, index) => (React.createElement(EventToken, { ...event, key: index, onClick: () => this.onEventTokenClick(event) })))));
        };
    }
    render() {
        const { data = [], displayQuantity } = this.props;
        const shownEvents = [...data];
        const hiddenEvents = shownEvents.length > displayQuantity
            ? shownEvents.splice(displayQuantity)
            : [];
        return (React.createElement("div", { className: "c-event-list" },
            React.createElement("div", { className: "c-event-list__tokens" }, this.renderEventTokens(shownEvents, 'c-event-list__tokens')),
            React.createElement("div", { className: "c-event-list__see-more" }, this.renderSeeMore(hiddenEvents))));
    }
};
EventTokenList.propTypes = {
    data: array.notEnumerable(),
    displayQuantity: number,
    onClick: eventListener,
    onContextMenuClick: eventListener,
    onDoubleClick: eventListener,
};
EventTokenList.defaultProps = {
    data: [],
    displayQuantity: 3,
};
EventTokenList = __decorate([
    AwesomeComponent({ api: EventTokenListAPI, type: ComponentType.DATA_DISPLAY })
], EventTokenList);
export default EventTokenList;
//# sourceMappingURL=event-token-list.js.map